













import { defineComponent, PropType } from '@nuxtjs/composition-api';

import SidebarSubheading from '../SidebarSubheading.vue';
import YearSelectorForm from './YearSelectorForm.vue';

interface YearSelectorEmitProps {
  emit: {
    (event: 'submit', year: string): void;
  };
}

export default defineComponent({
  components: {
    YearSelectorForm,
    SidebarSubheading,
  },
  props: {
    validationError: {
      type: String,
      default: null,
    },
    vehicleYears: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  setup(_: unknown, { emit }: YearSelectorEmitProps) {
    const handleSubmit = (year: string) => {
      emit('submit', year);
    };

    return {
      handleSubmit,
    };
  },
});
